<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">
  <div class="esf-main-sidebar__content">
    <h3 i18n='Address data edit modal title@@customerOverviewComponent.modalTitle.editAddress'>Edit address</h3>
    <form [formGroup]="updateAddressForm" (ngSubmit)="updateAddressFormSubmit(updateAddressForm)" id="updateAddressForm">
      <div class="esf-form-item esf-form-validation">
        <label for="editAddressType" class="esf-form-item__label" i18n='Form label text@@general.formLabel.addressType'>Address type</label>
        <div class="esf-select">
          <select class="esf-form-item__field esf-select__field selected-field" id="editAddressType" autocomplete="off" formControlName="type">
            <option [value]="'standard'" i18n='Form option@@general.formOption.standard'
                    [selected]="'standard' === selectedAddress.type"
                    [disabled]="checkIfAddressesStandard() && !selectedAddress.isStandard">Standard</option>
            <option [value]="'delivery'" i18n='Form option@@general.formOption.delivery'
                    [selected]="'delivery' === selectedAddress.type">Delivery</option>
            <option [value]="'additional'" i18n='Form option@@general.formOption.additional'
                    [selected]="'additional' === selectedAddress.type" *ngIf="'additional' === selectedAddress.type">Additional</option>
          </select>
        </div>
        <button class="esf-button esf-button--simple" type="button" *ngIf="selectedAddress.type === 'additional'">
          <svg class="esf-icon esf-button__icon" width="16" height="16">
            <use xlink:href="#esf-icon-info"></use>
          </svg>
          <span class="esf-button__icon-text" i18n="Form warning@@general.formWarning.changeToDeliveryType">Will change to delivery type if you submit your changes</span>
        </button>
      </div>
      <div class="esf-form-group" *ngIf="!selectedAddress.isStandard">
        <div class="esf-form-item esf-form-item--1-2 esf-form-validation">
          <label i18n='Form label text@@general.formLabel.salutation' class="esf-form-item__label" for="salutation">Salutation</label>
          <div class="name-prefix-wrapper">
            <div class="esf-check-radio">
              <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation" type="radio"
                     id="amr" value="mr">
              <label class="esf-check-radio__label esf-check-radio--radio__label" for="amr"
                     i18n='Form label text@@general.formLabel.Mr'>Mr.</label>
            </div>
            <div class="esf-check-radio">
              <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation" type="radio"
                     id="amrs" value="mrs">
              <label class="esf-check-radio__label esf-check-radio--radio__label" for="amrs"
                     i18n='Form label text@@general.formLabel.Mrs'>Mrs.</label>
            </div>
            <div class="esf-check-radio">
              <input class="esf-check-radio__input esf-check-radio--radio__input" formControlName="salutation"
                     type="radio" id="notSpecified" [value]='null'>
              <label class="esf-check-radio__label esf-check-radio--radio__label" for="notSpecified" i18n='Form label text@@general.formLabel.notSpecified'>Not specified</label>
            </div>
          </div>
        </div>
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="updateAddressForm.get('title')"
             [optional]="true"
             [placeholder]="flTranslations.i18nTitle"
             [label]="flTranslations.i18nTitle">
        </div>
      </div>
      <div class="esf-form-group" *ngIf="!selectedAddress.isStandard">
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="updateAddressForm.get('firstName')"
             [placeholder]="flTranslations.i18nFirstName"
             [label]="flTranslations.i18nFirstName">
        </div>
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="updateAddressForm.get('lastName')"
             [placeholder]="flTranslations.i18nLastName"
             [label]="flTranslations.i18nLastName">
        </div>
      </div>
      <div app-form-field-text-generic
           *ngIf="!selectedAddress.isStandard"
           [control]="updateAddressForm.get('company')"
           [optional]="true"
           [placeholder]="flTranslations.i18nCompany"
           [label]="flTranslations.i18nCompany">
      </div>
      <div class="esf-form-item esf-form-validation">
        <label i18n='Form label text@@general.formLabel.street' class="esf-form-item__label" for="street">Street</label>
        <input class="esf-form-item__field" id="street" i18n-placeholder="Form placeholder text@@general.formPlaceholder.street"
               placeholder="Enter street"
               formControlName="street"
               autocomplete="off"
               [appGooglePlaces]="updateAddressForm.value?.street"
               (onAddressSelect)="fillAddressValues($event)">
      </div>
      <div class="esf-form-group">
        <div class="esf-form-item esf-form-item--1-2 esf-form-validation">
          <label i18n='Form label textForm label text@@general.formLabel.postalCode' class="esf-form-item__label" for="postalCode">Post code</label>
          <input class="esf-form-item__field" id="postCode" i18n-placeholder="Form placeholder text@@general.formPlaceholder.postalCode"
                 placeholder="Enter Post code"
                 formControlName="postalCode"
                 autocomplete="off">
        </div>
        <div class="esf-form-item esf-form-item--1-2 esf-form-validation">
          <label i18n='Form label textForm label text@@general.formLabel.city' class="esf-form-item__label" for="city">City</label>
          <input type="text" class="esf-form-item__field" id="city" i18n-placeholder="Form placeholder text@@general.formPlaceholder.city"
                 placeholder="Enter city"
                 formControlName="city"
                 autocomplete="off">
        </div>
      </div>
      <div app-form-field-select
           [control]="updateAddressForm.get('country')"
           [label]="flTranslations.i18nCountry"
           [array]="countries"
           [valueKey]="'iso2'"
           [textKey]="'name'">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <app-submit-row-buttons [form]="'updateAddressForm'"
                          [isFieldValid]="customer.isEditable"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="customerOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition -is-open"
     (click)="customerOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
